interface Array<T> 
{
    /** Removes the first element === o from the calling array and returns true if successful */
    remove(o: T): boolean;
    /** Returns an array with all elements === o removed */
    removeAll(o: T): Array<T>;
}

Array.prototype.remove = function<T>(this: T[], o : T) 
{
    var index = this.indexOf(o);
    if (index != -1)
    {
        this.splice(index, 1);
        return true;
    }
    return false;
}

Array.prototype.removeAll = function<T>(this: T[], o : T) 
{
    return this.filter(e => e !== o);
}